import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';

import DisplayMonitor from '../shared/DisplayMonitor.jsx';
import RunCommandModal from '../shared/RunCommandModal.jsx';

import * as api from '../../api/api';
import * as socket from '../../socket';

class MonitorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDisplayId: 1,
      monitorData: [],
      isUserAdmin: api.isUserAdmin(),
    };

    this.props.updateLoader({
      loaded: false,
      message: '',
    });
  }

  async componentDidMount() {
    try {
      const devices = (await api.makeRequest(api.getEnabledDisplays())).data
        .data;
      const checkpoints = (
        await api.makeRequest(api.getCheckpointsDictionary())
      ).data.data;

      if (devices.length === 0) {
        this.props.updateLoader({
          message: 'Отсутствуют данные для отображения',
          loaded: true,
        });
      } else {
        this.setState({
          selectedDisplayId: devices[0].id,
          monitorData: devices.map((nowDisplay) => {
            return {
              display: {
                id: nowDisplay.id,
                name: nowDisplay.id,
                description: nowDisplay.description,
                checkpoint: checkpoints.find(
                  (checkpoint) => checkpoint.id === nowDisplay.checkpoint_id,
                ),
              },
              monitor: {
                currentState: {},
                lastSeen: null,
              },
            };
          }),
        });
      }
    } catch (err) {
      this.props.updateLoader({
        loaded: true,
        message: err.message,
      });
    }

    socket.getInstance().on('receivingMonitorData', (data) => {
      if (this.state.monitorData.length > 0) {
        let newMonitors = [];

        // console.log(data);
        // return;

        // let monitorData = JSON.parse(data);
        let monitorData = data;
        if (!Array.isArray(monitorData)) monitorData = [monitorData];

        for (let i = 0; i < monitorData.length; i++) {
          for (let j = 0; j < this.state.monitorData.length; j++) {
            if (monitorData[i].id == this.state.monitorData[j].display.id) {
              newMonitors.push({
                display: {
                  id: this.state.monitorData[j].display.id,
                  name: this.state.monitorData[j].display.name,
                  description: this.state.monitorData[j].display.description,
                  checkpoint: this.state.monitorData[j].display.checkpoint,
                },
                monitor: {
                  currentState: monitorData[i].currentState,
                  lastSeen: monitorData[i].lastSeen,
                },
              });
            }
          }
        }

        this.setState({
          monitorData: newMonitors,
        });

        this.props.updateLoader({
          loaded: true,
          message: '',
        });
      }
    });
  }

  componentWillUnmount() {
    socket.getInstance().removeAllListeners('receivingMonitorData');
  }

  handleMonitorClick(monitorId) {
    this.setState({ selectedDisplayId: monitorId });
  }

  render() {
    return (
      <div>
        <div
          className="alert alert-secondary alert-dismissible fade show"
          role="alert"
        >
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
            title="Закрыть"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <h5 className="m-0">
            <a className="collapse-link" data-toggle="collapse" href="#legend">
              Легенда
            </a>
          </h5>

          <div
            className="list-group list-group-horizontal-md mt-3 collapse"
            id="legend"
          >
            {/* <div className="d-flex align-items-center legend-item">
                            <div className="display-monitor-mobile-state rounded-circle bg-success"></div><div className="ml-3">проблем нет</div>
                        </div>
                        <div className="d-flex align-items-center legend-item">
                            <div className="display-monitor-mobile-state rounded-circle bg-warning"></div><div className="ml-3">утройство функционирует, однако есть некритичные проблемы</div>
                        </div>
                        <div className="d-flex align-items-center legend-item">
                            <div className="display-monitor-mobile-state rounded-circle bg-danger"></div><div className="ml-3">утройство не функционирует вследствие ошибки</div>
                        </div>
                        <div className="d-flex align-items-center legend-item">
                            <div className="display-monitor-mobile-state rounded-circle bg-secondary"></div><div className="ml-3">данные о работоспособности не получены</div>
                        </div> */}
            <div className="d-flex align-items-center legend-item">
              <div className="display-monitor-mobile-state rounded-circle bg-success"></div>
              <div className="ml-3">
                устройство в данный момент отображает данные
              </div>
            </div>
            <div className="d-flex align-items-center legend-item">
              <div className="display-monitor-mobile-state rounded-circle bg-secondary"></div>
              <div className="ml-3">
                устройство в сети, в данный момент не отображает данные
              </div>
            </div>
            <div className="d-flex align-items-center legend-item">
              <div className="display-monitor-mobile-state rounded-circle bg-warning"></div>
              <div className="ml-3">устройство не в сети</div>
            </div>
          </div>
        </div>

        <div className="monitor__wrapper">
          {this.state.monitorData.map((nowMonitorData, i) => {
            return (
              <DisplayMonitor
                key={i.toString()}
                monitorData={nowMonitorData}
                isUserAdmin={this.state.isUserAdmin}
                onClick={() =>
                  this.handleMonitorClick(nowMonitorData.display.id)
                }
              />
            );
          })}
          <RunCommandModal
            displayId={this.state.selectedDisplayId}
            updateLoader={this.props.updateLoader}
          />
        </div>
      </div>
    );
  }
}

export default MonitorPage;
